// Delegate so it also works for sections loaded after initial page load
document.addEventListener('click', (event) => {
  // First find the nearest trigger button
  const trigger = event.target.closest('.js-new-video-wrapper-trigger');
  if (!trigger) return;

  // Ensure this trigger lives inside our section parent
  if (!trigger.closest('.new-video-wrapper')) return;

  const allVideos = trigger.querySelectorAll('.js-new-video-wrapper-video');
  const video = [...allVideos].find((v) => v.offsetParent !== null) ?? allVideos[0];
  if (!video) return;

  if (video.paused) {
    trigger.classList.add('is-playing');
    video.play().catch(() => {});
  } else {
    video.pause();
    trigger.classList.remove('is-playing');
  }

  video.addEventListener(
    'ended',
    () => {
      trigger.classList.remove('is-playing');
    },
    { once: true }
  );
});
